module.exports = __webpack_public_path__ + "static/media/train.ae35dd2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/train.svg
// module id = 255
// module chunks = 0